import * as userUtils from '@Utils/user';
import { key, isLoggedInUserDropdownOpenKey, isPersonalizationUserDropdownOpenKey } from './HeaderComponentConstants';

export function headerComponent(state) {
  return state.get(key);
}

export function currentUser(state) {
  return headerComponent(state).get('currentUser');
}
export function currentUserSettings(state) {
  return headerComponent(state).getIn(['currentUser', 'details', 'settings']);
}

// User-based selectors for Header component
export function companyPageUrl(state) {
  const settings = currentUserSettings(state);
  return settings && settings.companyPageUrl;
}
export function companyLogoUrl(state) {
  const settings = currentUserSettings(state);
  return settings && settings.companyLogoUrl;
}
export function userName(state) {
  return userUtils.getFirstLastName(currentUser(state));
}
export function initials(state) {
  return userUtils.getInitials(currentUser(state));
}
export function isRMCLicense(state) {
  return userUtils.isRMCLicense(currentUser(state));
}
export function isAnonymousUser(state) {
  return userUtils.isAnonymousUser(currentUser(state));
}
export function isShibbolethUser(state) {
  return userUtils.isShibbolethUser(currentUser(state));
}
export function isAnonShibbolethLogin(state) {
  return userUtils.isAnonShibbolethLogin(currentUser(state));
}
export function userHasRegistration(state) {
  return userUtils.userHasRegistration(currentUser(state));
}
export function userHasInstitutionLogin(state) {
  return userUtils.userHasInstitutionLogin(currentUser(state));
}

// Other useful stuff
export function activeResults(state) {
  return headerComponent(state).get('activeResults');
}
export function isAEMock(state) {
  return headerComponent(state).get('isAEMock');
}
export function isUserDropdownOpen(state, isOpenKey) {
  return headerComponent(state).getIn(['userDropdownsOpen', isOpenKey]);
}
export function isLoggedInUserDropdownOpen(state) {
  return isUserDropdownOpen(state, isLoggedInUserDropdownOpenKey);
}
export function isPersonalizationUserDropdownOpen(state) {
  return isUserDropdownOpen(state, isPersonalizationUserDropdownOpenKey);
}

// TODO move user-related stuff to separate actions/selectors/reducer
// for currentUser.details Containers/UserDetails can be used instead
export function resultsPerPageIELimit(state) {
  return headerComponent(state).getIn(['currentUser', 'devOptions', 'resultsPerPageIELimit']);
}
export function email(state) {
  return headerComponent(state).getIn(['currentUser', 'details', 'email']);
}
